import axios from 'axios'

window.BASE_URL = `${location.origin}/`

let VERBOSE_LOGGING = false // log almost everything
let ALLOW_MOCK = false  // allow mocking
let FORCE_MOCK = false // always send out mock data
let SIMULATE_SUCCESS_FALSE = false // api testing force fail all (data.success = false)

// Configurable variables
// VERBOSE_LOGGING = true
// ALLOW_MOCK = true
// FORCE_MOCK = true
// SIMULATE_SUCCESS_FALSE = true
// End of configurable variables

// Layer for api requests

const api = {
  _path (path) {
    const url = new URL(path, window.BASE_URL)
    return url.href
  },
  _mock (name, data) {
    console.info(`> Mocking data: ${name} > returning: ${JSON.stringify(data)}`)
    if (SIMULATE_SUCCESS_FALSE) {
      data.success = false
      console.warn('IMPORTANT: SIMULATE_SUCCESS_FALSE flag in api.js is true, forcing data.success = false')
    }
    return {
      status: 200,
      data
    }
  },
  async _call (name, mock, call) {
    if (FORCE_MOCK && Object.keys(mock).length > 0) {
      console.warn('IMPORTANT: FORCE_MOCK flag in api.js is true, forcing to mock data.')
      return api._mock(name, mock)
    }
    try {
      const result = await call()
      if (VERBOSE_LOGGING) {
        console.info(`Succeed in calling: ${name}`)
        console.log(result)
        console.log(result.data)
      }
      return result
    } catch (e) {
      if (ALLOW_MOCK && Object.keys(mock).length > 0) {
        console.warn(`Can't reach api of '${name}', falling back to the mocked data.`)
        return api._mock(name, mock)
      }
      console.error(`Can't reach api of '${name}'`)
      throw e
    }
  },
  profile: {
    async get () {
        return await api._call('profile.get', {
        }, async () => await axios(api._path('member/api/profile')))
    }
  },
  wallet: {
    async get () {
      return await api._call('wallet.get', {
      }, async () => await axios(api._path('member/api/wallet')))
    }
  },
  deposit: {
    async getSlip(requestId) {
      return await api._call('deposit.getSlip', {
        success: true,
        imageURL: 'https://via.placeholder.com/150'
      }, async () => {
        return await axios.get(
          api._path(`member/api/deposit/${requestId}/slip`)
        )
      });
    },
    async uploadSlip(formData, requestId) {
      return await api._call('deposit.uploadSlip', {
        success: true,
        imageURL: 'https://via.placeholder.com/150'
      }, async () => {
        return await axios.post(
          api._path(`member/api/deposit/${requestId}/slip`),
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      });
    },
    async getUserCurrentStep() { // WAIT_USER_CONFIRM, WAIT_PROCESSED
      return await api._call('deposit.getUserCurrentStep', {
      }, async () => await axios(api._path('member/api/deposit/user-current-step')))
    },
    async request (amount) {
      return await api._call('deposit.request', {
      }, async () => await axios.post(api._path('/member/api/deposit/request'), { amount }))
    },
    async confirm (requestId) {
      return await api._call('deposit.confirm', {
      }, async () => await axios(api._path(`member/api/deposit/${requestId}/confirm`)))
    },
    async cancel (requestId) {
      return await api._call('deposit.cancel', {
      }, async () => await axios.delete(api._path(`member/api/deposit/${requestId}`)))
    },
    async isProcessed (requestId) {
      return await api._call('deposit.isProcessed', {
      }, async () => await axios(api._path(`member/api/deposit/${requestId}/isProcessed`)))
    }
  },
  withdraw: { // PRE_VERIFY, WAIT_USER_CONFIRM, WAIT_PROCESSED
    async getUserCurrentStep() {
      return await api._call('withdraw.getUserCurrentStep', {
        success: true,
        step: 'NONE',
        request: {
          requestId: '1',
          withdrawAmount: 10000,
          expire: -1
        }
      }, async () => await axios(api._path('member/api/withdraw/user-current-step')))
    },
    async fee (amount) {
      return await api._call('withdraw.fee', {
        success: true,
        fee: 50
      }, async () => await axios(api._path('member/api/withdraw/fee'), {
        params: {
          amount
        }
      }))
    },
    async request (amount) {
      return await api._call('withdraw.request', {
        success: true,
        request: {
          requestId: '1',
          withdrawAmount: amount,
          expire: '1'
        }
      }, async () => await axios.post(api._path('/member/api/withdraw/request'), { amount }))
    },
    async cancel (requestId) {
      return await api._call('withdraw.cancel', {
        success: true,
      }, async () => await axios.delete(api._path(`member/api/withdraw/${requestId}`)))
    },
    async verifyOTP (otp) {
      return await api._call('withdraw.verifyOTP', {
        success: true, // true / false,
        requestId: '1',
      }, async () => await axios.post(api._path('/member/api/withdraw/confirm-otp'), { otp }))
    },
    async resendOTP () {
      return await api._call('withdraw.resendOTP', {
      }, async () => await axios(api._path('/member/api/withdraw/resend-otp')))
    },
    async confirm (requestId) {
      return await api._call('withdraw.confirm', {
        success: true
      }, async () => await axios(api._path(`member/api/withdraw/${requestId}/confirm`)))
    }
  },
  activity: { // this.$api.activity.list()
    async list () {
      return await api._call('activity.list', {
        success: true,
        activities: [
          {
            type: 'RECEIVE_CONTRACT_REQUEST_MONEY',
            datetime: 1560155756000,
            activityDetail: {
              contractId: 1,
              requestId: 5,
              from: { // user model
                id: 6,
                avatarPath: 'https://via.placeholder.com/150',
                name: 'Emmanuelle Predovic',
                memberType: 'korgoo'
              },
              moneyPayload: {
                amount: 98491.23,
                interest: 0.07,
                duration: 24, // 12 months
              }
            }
          },
          {
            type: 'RECEIVE_CONTRACT_REQUEST_MONEY',
            datetime: 1560155656000,
            activityDetail: {
              contractId: 1,
              requestId: 4,
              from: { // user model
                id: 4,
                avatarPath: 'https://via.placeholder.com/150',
                name: 'Dell Price',
                memberType: 'korgoo'
              },
              moneyPayload: {
                amount: 750492.00,
                interest: 0.15,
                duration: 12, // 12 months
              }
            }
          },
          {
            type: 'APPROVE_CONTRACT_REQUEST_MONEY',
            datetime: 1560155556000,
            activityDetail: {
              contractId: 1,
              requestId: 3,
              from: { // user model
                id: 4,
                avatarPath: 'https://via.placeholder.com/150',
                name: 'Dell Price',
                memberType: 'korgoo'
              },
              moneyPayload: {
                amount: 67800.00,
              }
            }
          },
          {
            type: 'RECEIVE_CONTRACT_REQUEST_THING',
            datetime: 1560155456000,
            activityDetail: {
              contractId: 1,
              requestId: 2,
              from: { // user model
                id: 4,
                avatarPath: 'https://via.placeholder.com/150',
                name: 'Dell Price',
                memberType: 'korgoo'
              },
              moneyPayload: {
                amount: 90560.00,
                interest: 0.15,
                duration: 12, // 12 months
              }
            }
          },
        ]
      }, async () => await axios(api._path(`member/api/activities/list`))) // TODO: Edit API Path
    },
  },
  transaction: {
    async list () {
      return await api._call('transaction.list', {
        success: true,
        transactions: [
          {
            id: 1,
            type: 'deposit',
            amount: 2000.00,
            datetime: 1560155416000,
          },
          {
            id: 2,
            type: 'withdraw',
            amount: 1234.00,
            datetime: 1560155416000,
          },
          {
            id: 3,
            type: 'fee',
            amount: 100.00,
            datetime: 1560155416000,
          },
          {
            id: 4,
            contractNo: 'CONTRACTNO',
            party_name: 'PAYTYNAME LOAN',
            type: 'loan',
            amount: 1000.00,
            datetime: 1560155416000,
            contractId: 141414,
            personName: 'ประยุทธ์ จันทร์ชะเอม'
          },
          {
            id: 5,
            contractNo: 'CONTRACTNO',
            party_name: 'PAYTYNAME LEND',
            type: 'lend',
            amount: 2000.00,
            datetime: 1560155416000,
            contractId: 151515,
            personName: 'ประยุทธ์ ยังโอม'
          },
        ]
      }, async () => await axios(api._path(`member/api/transactions/list`)))
    },
  },
  creditbureau: {
    async listOnlyContract (userId = -1, contractId = -1) {
      let params = {}
      if (contractId !== -1) {
        params = { contractId }
      }
      if (userId === -1) {
        return await api._call('creditbureau.listOnlyContract.self', {
          success: true,
          creditbureaus: [
            {
              id: 4,
              contractNo: 'CTM190003',
              daysLate: 83,
              amount: 15000
            },
            {
              id: 5,
              contractNo: 'CTM190002MOCK',
              daysLate: 83,
              amount: 15000
            }
          ]
        }, async () => await axios(api._path(`member/api/credit-bureau/list-contract`), { params }))
      } else {
        return await api._call('creditbureau.listOnlyContract.single', {
          success: true,
          creditbureaus: [
            {
              id: 4,
              contractNo: 'CTM190003',
              daysLate: 83,
              amount: 15000
            },
            {
              id: 5,
              contractNo: 'CTM190002MOCK',
              daysLate: 83,
              amount: 15000
            }
          ]
        }, async () => await axios(api._path(`member/api/credit-bureau/list-contract/${userId}`), { params }))
      }
    },
    async list (userId = -1, contractId = -1) {
      let params = {}
      if (contractId !== -1) {
        params = { contractId }
      }
      if (userId === -1) {
        return await api._call('creditbureau.list.self', {
          success: true,
          creditbureaus: [
            {
              id: 1,
              contractId: 1,
              daysLate: 0,
              amount: 112,
              isLastPeriod: false,
              contractNo: 12,
              period: 1,
              totalPeriod: 12,
            },
            {
              id: 2,
              contractId: 1,
              daysLate: 31,
              amount: 112,
              isLastPeriod: false,
              contractNo: 12,
              period: 2,
              totalPeriod: 12,
            },
            {
              id: 3,
              contractId: 1,
              daysLate: 61,
              amount: 112,
              isLastPeriod: false,
              contractNo: 12,
              period: 3,
              totalPeriod: 12,
            },
            {
              id: 4,
              contractId: 1,
              daysLate: 91,
              amount: 112,
              isLastPeriod: true,
              contractNo: 12,
              period: 4,
              totalPeriod: 12,
            }
          ]
        }, async () => await axios(api._path(`member/api/credit-bureau/list`), {params}))
      } else {
        return await api._call('creditbureau.list.single', {
          success: true,
          creditbureaus: [
            {
              id: 1,
              contractId: 1,
              daysLate: 0,
              amount: 112,
              isLastPeriod: false,
              contractNo: 12,
              period: 1,
              totalPeriod: 12,
            },
            {
              id: 2,
              contractId: 1,
              daysLate: 31,
              amount: 112,
              isLastPeriod: false,
              contractNo: 12,
              period: 2,
              totalPeriod: 12,
            },
            {
              id: 3,
              contractId: 1,
              daysLate: 61,
              amount: 112,
              isLastPeriod: false,
              contractNo: 12,
              period: 3,
              totalPeriod: 12,
            },
            {
              id: 4,
              contractId: 1,
              daysLate: 91,
              amount: 112,
              isLastPeriod: true,
              contractNo: 12,
              period: 4,
              totalPeriod: 12,
            }
          ]
        }, async () => await axios(api._path(`member/api/credit-bureau/list/${userId}`), {params}))
      }
    }
  },
  contract: {
    async getInvoices (contractId) {
      return await api._call('contract.getInvoices', {
      }, async () => await axios(api._path(`member/api/contract/invoices/list/${contractId}`)))
    },
    async calculatePayPerPeriod (amount, interestRate, duration, downPaymentAmount = -1) {
      if (downPaymentAmount === -1) {
        return await api._call('contract.calculatePayPerPeriod', {
          success: true,
          perPeriod: -1
        }, async () => await axios.post(api._path(`member/api/contract/calculate-per-period`), {
          moneyPayload: {
            amount,
            interestRate,
            duration
          }
        }))
      } else {
        return await api._call('contract.calculatePayPerPeriod.withDownPaymentAmount', {
          success: true,
          perPeriod: -1
        }, async () => await axios.post(api._path(`member/api/contract/calculate-per-period`), {
          moneyPayload: {
            amount,
            interestRate,
            duration,
            downPaymentAmount
          }
        }))
      }
    },

    async calculatePMT (amount, interestRate, duration, downPaymentAmount = 0) {
      return await api._call('contract.calculatePMT', {
        success: true,
        perPeriod: -1
      }, async () => await axios.post(api._path(`member/api/contract/calculate-pmt`), {
        moneyPayload: {
          amount,
          interestRate,
          duration,
          downPaymentAmount
        }
      }))
    },
    async listAvailableContractPerson (userId = -1, searchQuery = '*') {
      if (userId === -1) {
        return await api._call('contract.listAvailableContractPerson.all', {
          success: true,
          people: [
            {
              id: 1,
              avatarPath: 'https://via.placeholder.com/150',
              name: 'ตาหวาน',
              memberType: 'haigoo'
            },
            {
              id: 2,
              avatarPath: 'https://via.placeholder.com/150',
              name: 'Phawan Biggy',
              memberType: 'haigoo'
            }
          ]
        }, async () => await axios(api._path(`member/api/lenders`))) // TODO: Edit API Path
      } else {
        return await api._call('contract.listAvailableContractPerson.single', {
          success: true,
          people: [
            {
              id: 1,
              avatarPath: 'https://via.placeholder.com/150',
              name: 'ตาหวาน',
              memberType: 'haigoo'
            }
          ]
        }, async () => await axios(api._path(`member/api/lender/${userId}`))) // TODO: Edit API Path
      }
    },
    request: {
      thing: {
        // imageFormData API Endpoint, parse "formData", return success and imageURL
        async uploadPhoto(formData) {
          return await api._call('contract.request.thing.uploadPhoto', {
            success: true,
            imageURL: 'https://via.placeholder.com/150'
          }, async () => {
            return await axios.post(
              api._path(`member/api/contract/thing/upload-photos`), // TODO: Edit API Path
              formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            )
          })
        }
      },
      newContract: {
        async fee (amount, downPaymentAmount, isMortgage = false) {
          let finalAmount = amount
          // console.log('amount', amount)
          // console.log('downPaymentAmount', downPaymentAmount)
          if (downPaymentAmount === undefined || isNaN(downPaymentAmount) || downPaymentAmount === 0) {
          } else {
            finalAmount = amount - downPaymentAmount
          }
          return await api._call('contract.request.newContract.fee', {
            success: true,
            isMortgage: isMortgage,
            fee: 1000.00,
            lender_fee: 120.00,
            viewCreditFee: 500.00, // for KORGOO side
          }, async () => await axios(api._path(`member/api/contract/fee`), {
            params: {
              isMortgage: isMortgage,
              amount: finalAmount
            }
          })) // TODO: Edit API Pat
        },
        // moneyPayload: { haigooId, amount, interest, duration, payOnEvery }
        async money(moneyPayload, sendCredit) {
          return await api._call('contract.request.newContract.money', {
            success: true
          }, async () => await axios.post(api._path(`member/api/contract/money/create`), { sendCredit, moneyPayload })) // TODO: Edit API Path
        },
        // thingPayload: { thingName, downPaymentAmount, imageURLs[] }
        async thing(moneyPayload, thingPayload, sendCredit) {
          return await api._call('contract.request.newContract.thing', {
            success: true
          }, async () => await axios.post(api._path(`member/api/contract/thing/create`), { sendCredit, moneyPayload, thingPayload })) // TODO: Edit API Path
        },
        // moneyPayload: { haigooId, amount, interest, duration, payOnEvery }
        async mortgage(moneyPayload, thingPayload, sendCredit) {
          return await api._call('contract.request.newContract.mortgage', {
            success: true
          }, async () => await axios.post(api._path(`member/api/contract/mortgage/create`), { sendCredit, moneyPayload, thingPayload })) // TODO: Edit API Path
        },
      },
    },
    async listForPay () {
      return await api._call('contract.listForPay', {
      }, async () => await axios.get(api._path(`member/api/contract/list`), {
        params: {
          can_pay: true
        }
      }))
    },
    async list (contractId = -1) {
      if (contractId === -1) {
        return await api._call('contract.list.all', {
          success: true,
          contracts: [
            {
              id: 5,
              type: 'MONEY', // 'MONEY' or 'THING'
              activeUserSide: 'KORGOO', // 'HAIGOO' or 'KORGOO' => type of the user who made request
              // HAIGOO if haigooId = activeUser.ID -> show in บัญชีลูกหนี้ (ie. active user เป็น เจ้าหนี้)
              // KORGOO if korgooId = activeUser.ID -> show in บัญชีเจ้าหนี้ (ie. active user เป็น ลูกหนี้)
              status: 'wait_for_approve', // ['wait_for_approve', 'active', 'canceled', 'disputed', 'ended']
              datetime: 1560155456000,
              info: {
                moneyPayload: {
                  haigoo: {
                    id: 1,
                    avatarPath: 'https://via.placeholder.com/150',
                    name: 'ตาหวาน',
                    memberType: 'haigoo'
                  },
                  korgoo: {
                    id: 2,
                    avatarPath: 'https://via.placeholder.com/150',
                    name: 'Phawan Biggy',
                    memberType: 'korgoo'
                  },
                  amount: 50000.00,
                  interest: 0.10,
                  duration: 12,
                  payOnEvery: 20,
                  fee: 1000.00,
                  perPeriod: 3300.00
                },
                // have thingPayload if type = 'THING'
                // thingPayload: {
                //   thingName: 'SAMSUNG Something 24K Magic TV',
                //   downPaymentAmount: 20000.00,
                //   imageURLs: ['https://via.placeholder.com/150']
                // }
              }
            },
            {
              id: 6,
              type: 'THING', // 'MONEY' or 'THING'
              activeUserSide: 'HAIGOO', // 'HAIGOO' or 'KORGOO' => type of the user who made request
              // HAIGOO if haigooId = activeUser.ID -> show in บัญชีลูกหนี้ (ie. active user เป็น เจ้าหนี้)
              // KORGOO if korgooId = activeUser.ID -> show in บัญชีเจ้าหนี้ (ie. active user เป็น ลูกหนี้)
              status: 'wait_for_approve', // ['wait_for_approve', 'active', 'canceled', 'disputed', 'ended']
              datetime: 1560155452000,
              info: {
                moneyPayload: {
                  korgoo: {
                    id: 1,
                    avatarPath: 'https://via.placeholder.com/150',
                    name: 'ตาหวาน',
                    memberType: 'korgoo'
                  },
                  haigoo: {
                    id: 2,
                    avatarPath: 'https://via.placeholder.com/150',
                    name: 'Phawan Biggy',
                    memberType: 'haigoo'
                  },
                  amount: 60000.00,
                  interest: 0.10,
                  duration: 12,
                  payOnEvery: 20,
                  fee: 1000.00,
                  perPeriod: 3300.00
                },
                thingPayload: {
                  thingName: 'SAMSUNG Something 24K Magic TV',
                  downPaymentAmount: 20000.00,
                  imageURLs: ['https://via.placeholder.com/150']
                }
              }
            },
            {
              id: 7,
              type: 'MONEY', // 'MONEY' or 'THING'
              activeUserSide: 'KORGOO', // 'HAIGOO' or 'KORGOO' => type of the user who made request
              // HAIGOO if haigooId = activeUser.ID -> show in บัญชีลูกหนี้ (ie. active user เป็น เจ้าหนี้)
              // KORGOO if korgooId = activeUser.ID -> show in บัญชีเจ้าหนี้ (ie. active user เป็น ลูกหนี้)
              status: 'wait_for_approve', // ['wait_for_approve', 'active', 'canceled', 'disputed', 'ended']
              datetime: 1560155416000,
              info: {
                moneyPayload: {
                  korgoo: {
                    id: 1,
                    avatarPath: 'https://via.placeholder.com/150',
                    name: 'ตาหวาน',
                    memberType: 'korgoo'
                  },
                  haigoo: {
                    id: 2,
                    avatarPath: 'https://via.placeholder.com/150',
                    name: 'Phawan Biggy',
                    memberType: 'haigoo'
                  },
                  amount: 70000.00,
                  interest: 0.10,
                  duration: 12,
                  payOnEvery: 20,
                  fee: 1000.00,
                  perPeriod: 3300.00
                }
              }
            }
          ]
        }, async () => await axios.get(api._path(`member/api/contract/list`)))
      } else {
        return await api._call('contract.list.single', {
          success: true,
          contracts: [{
            id: 5,
            type: 'THING', // 'MONEY' or 'THING'
            activeUserSide: 'KORGOO', // 'HAIGOO' or 'KORGOO' => type of the user who made request
              // HAIGOO if haigooId = activeUser.ID -> show in บัญชีลูกหนี้ (ie. active user เป็น เจ้าหนี้)
              // KORGOO if korgooId = activeUser.ID -> show in บัญชีเจ้าหนี้ (ie. active user เป็น ลูกหนี้)
            status: 'wait_for_approve', // ['wait_for_approve', 'active', 'canceled', 'disputed', 'ended']
            datetime: 1560155452000,
            info: {
              moneyPayload: {
                korgoo: {
                  id: 1,
                  avatarPath: 'https://via.placeholder.com/150',
                  name: 'ตาหวาน',
                  memberType: 'korgoo'
                },
                haigoo: {
                  id: 2,
                  avatarPath: 'https://via.placeholder.com/150',
                  name: 'Phawan Biggy',
                  memberType: 'haigoo'
                },
                lender_fee: 120.00,
                amount: 30000.00,
                interest: 0.10,
                duration: 12,
                payOnEvery: 20,
                fee: 1000.00,
                perPeriod: 3300.00
              },
              // have thingPayload if type = 'THING'
              thingPayload: {
                thingName: 'SAMSUNG Something 24K Magic TV',
                downPaymentAmount: 20000.00,
                imageURLs: ['https://via.placeholder.com/150']
              }
            }
          }]
        }, async () => await axios.get(api._path(`member/api/contract/list/${contractId}`)))
      }
    },
    async listExempt (contractId = -1) {
      return await api._call('contract.list-exempt.single', {},
      async () => await axios.get(api._path(`member/api/contract/list-exempt/${contractId}`)))
    },
    async updateExempt (contractId, patch) {
      return await api._call('contract.updateExempt', {
        success: true
      }, async () => await axios.post(api._path(`member/api/contract/mutate/update-exempt/${contractId}`), { patch }))
    },
    async cancelExempt (contractId) {
      return await api._call('contract.cancelExempt', {
        success: true
      }, async () => await axios.post(api._path(`member/api/contract/mutate/cancel-exempt/${contractId}`)))
    },
    async listLand (contractId = -1) {
        return await api._call('contract.list-land.single', {},
        async () => await axios.get(api._path(`member/api/contract/list-land/${contractId}`)))
    },
    async updateLand (contractId, patch) {
      return await api._call('contract.updateLand', {
        success: true
      }, async () => await axios.post(api._path(`member/api/contract/mutate/update-land/${contractId}`), { patch }))
    },
    actions: {
      haigoo: { // ผู้ให้กู้
        createChildContract: {
          async create (contractId, patch) {
            return await api._call('contract.actions.haigoo.createChildContract.create', {
              success: true
            }, async () => await axios.post(api._path(`member/api/contract/mutate/create-child-contract/${contractId}`), { patch }))
          },
        },
        waitForApprove: {
          async approve (contractId) {
            return await api._call('contract.actions.haigoo.waitForApprove.approve', {
              success: true
            }, async () => await axios(api._path(`member/api/contract/action/approve/${contractId}`)))
          },
          // patch: { interest }
          async dispute (contractId, patch) {
            return await api._call('contract.actions.haigoo.waitForApprove.dispute', {
              success: true
            }, async () => await axios.post(api._path(`member/api/contract/mutate/dispute/${contractId}`), { patch }))
          },
          async deny (contractId) {
            return await api._call('contract.actions.haigoo.waitForApprove.deny', {
              success: true
            }, async () => await axios(api._path(`member/api/contract/action/reject/${contractId}`)))
          }
        },
        active: {
          async postpone (contractId) {
            return await api._call('contract.actions.haigoo.active.postpone', {
              success: true
            }, async () => await axios(api._path(`member/api/contract/action/postpone/${contractId}`)))
          },
          async cancel (contractId) {
            return await api._call('contract.actions.haigoo.active.cancel', {
              success: true
            }, async () => await axios(api._path(`member/api/contract/action/cancel/${contractId}`)))
          }
        }
      },
      korgoo: { // ผู้ขอกู้
        active: {
          async requestPostpone (contractId) {
            return await api._call('contract.actions.korgoo.active.requestPostpone', {
              success: true
            }, async () => await axios(api._path(`member/api/contract/action/request-postpone/${contractId}`)))
          },
          async requestCancel (contractId) {
            return await api._call('contract.actions.korgoo.active.requestCancel', {
              success: true
            }, async () => await axios(api._path(`member/api/contract/action/request-cancel/${contractId}`)))
          }
        },
        disputed: {
          async accept (contractId) {
            return await api._call('contract.actions.korgoo.disputed.accept', {
              success: true
            }, async () => await axios(api._path(`member/api/contract/action/accept-dispute/${contractId}`)))

          },
          async reject (contractId) {
            return await api._call('contract.actions.korgoo.disputed.reject', {
              success: true
            }, async () => await axios(api._path(`member/api/contract/action/reject-dispute/${contractId}`)))
          }
        }
      }
    }
  },
  pay: {
    async getInvoices (contractId) {
      return await api._call('pay.getInvoices', {
        success: true,
        invoices: [
          {
            id: 80,
            periodNum: 1,
            amount: 920.00,
            interestAmount: 138.00,
            isPaid: true,
            dueDate: 1558002992000, // 1 month ago
          },
          {
            id: 81,
            periodNum: 2,
            amount: 920.00,
            interestAmount: 138.00,
            isPaid: false,
            dueDate: 1560679200000, // current month but passed
          },
          {
            id: 82,
            periodNum: 3,
            amount: 920.00,
            interestAmount: 138.00,
            isPaid: false,
            dueDate: 1563273337000, // 1 month later
          },
          {
            id: 83,
            periodNum: 4,
            amount: 920.00,
            interestAmount: 138.00,
            isPaid: false,
            dueDate: 1565951737000, // 2 month later
          }
        ]
      }, async () => {
        const result = await axios(api._path(`member/api/contract/invoices/list/${contractId}?unpaid=true`))
        // TODO: Job -> Data structure manipulation here
        // Expecting something like in mock data
        // Mock data is { data: <mock data> }
        return result
      })
    },
    async payInvoices(contractId, invoiceArray) { // contractId is just a ref
      return await api._call('pay.payInvoices', {
        success: true,
      }, async () => await axios.post(api._path(`member/api/contract/pay`), {
        contractId,
        invoiceArray
      }))
    },
    async payContractMortgage(contractId, amount, advanced_days = 0) { // contractId is just a ref
      return await api._call('pay.payContractMortgage', {
        success: true,
      }, async () => await axios.post(api._path(`member/api/contract/pay-contract-mortgage`), {
        contractId,
        amount,
        advanced_days
      }))
    },
    async payDummyContractMortgage(contractId, amount, advanced_days = 0) { // contractId is just a ref
      return await api._call('pay.payContractMortgage', {
        success: true,
      }, async () => await axios.post(api._path(`member/api/contract/pay-dummy-contract-mortgage`), {
        contractId,
        amount,
        advanced_days
      }))
    }
  }
}

export default api
